import { PageMeta } from 'types/Pages'

export const PageMetaSetting: PageMeta = {
  location: '/blog/:id',
  title: 'Editar post',
  endpoint: '/public/blog',
  breadcrumbs: [],
}
